<template>
  <div ref="editCard" class="edit-modal-window" @paste="handlePaste($event)">
    <div class="edit-card-container">
      <div class="header">
        <span class="edit-modal-window-title clickable" @click="copyTitleToClipboard()">
          Редактирование карточки
          <i>{{ inBoardId }}</i>
        </span>
        <font-awesome-icon class="close-icon" icon="window-close" size="lg" @click="cancel()" />
      </div>

      <EditCardContent class="tab-content-card" :card="card" @cancel="cancel()" />
      <CardChat class="tab-content-chat" :card="card" />
      <CardEvents class="tab-content-history" :card="card" />

      <div class="drag-over-overlay-container" v-if="isDragOver">
        <div class="drag-over-overlay">
          <font-awesome-icon class="icon" icon="file-upload" size="lg" />
          <span class="text">Перетащите файл сюда, чтобы прикрепить его к карточке</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CardEvents from "./CardEvents.vue";
import CardChat from "./CardChat.vue";
import EditCardContent from "./EditCardContent.vue";

import urlManager from "@/common/urls";
import SimpleClipboard from "@/common/simpleClipboard";

import FileUploader from "@/common/fileUploader";
import DragHandler from "@/common/dragHandler";
import clickHelper from "../../../common/clickHelper";

export default {
  name: "EditCard",
  props: ["card"],
  components: { CardEvents, EditCardContent, CardChat },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    id() {
      if (!this.card) return 0;

      return this.card.id;
    },
    inBoardId() {
      if (!this.card) return 0;

      return this.card.in_board_id;
    }
  },
  methods: {
    copyTitleToClipboard() {
      if (!this.card) return;

      if (!clickHelper.isRealClick()) return;

      new SimpleClipboard().copyText(urlManager.getCardUrl(this.card));
      this.$snotify.success(`Ссылка на карточку ${this.card.in_board_id} скопирована`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    handlePaste(event) {
      var cb = event.clipboardData;

      if (!cb || !cb.files || !cb.files.length) {
        //no files was pasted
        return false;
      }

      const fileUploader = new FileUploader(this, this.card);
      const files = [];
      for (let i = 0; i < cb.files.length; i++) {
        const file = cb.files[i];
        files.push(file);
        fileUploader.fixName(file);
        fileUploader.addToUploadFiles(file);
      }

      this.$nextTick(() => {
        //it's hack to draw progress before we really starts to uploads
        for (let i = 0; i < files.length; i++) {
          fileUploader.uploadFile(files[i]);
        }
      });

      event.preventDefault();
      event.stopPropagation();

      return true;
    },
    cancel() {
      this.$emit("cancel");
      //this.$modal.hide("EditCard");
    }
  },
  data() {
    return {
      files: [],
      dragHandler: null,
      isDragOver: false
    };
  },
  mounted() {
    this.dragHandler = new DragHandler(this.$refs.editCard);

    const dragAndDropCapable = this.dragHandler.determineDragAndDropCapable();
    if (!dragAndDropCapable) {
      return;
    }

    this.dragHandler.startCallback = () => {
      this.isDragOver = true;
    };

    this.dragHandler.stopCallback = () => {
      this.isDragOver = false;
    };

    this.dragHandler.dropCallback = (files) => {
      const fileUploader = new FileUploader(this, this.card);
      fileUploader.uploadFiles(files);
    };

    this.dragHandler.subscribe();
  },
  watch: {
    card: function (newCard) {
      if (newCard && newCard.id && newCard.board_id) {
        this.$store.dispatch("boards/activateBoard", newCard.board_id);
      }
    }
  }
};
</script>

<style lang="postcss">
.edit-card-container {
  margin: 0 0.5em;
  border-radius: 10px;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 10fr auto 6fr;
  grid-gap: 0.5em;
  grid-template-areas:
    "header"
    "card-content"
    "chat"
    "history";

  .header {
    margin-top: 0.5em;
    grid-area: header;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr auto;
    grid-template-areas: "tabs close";
  }

  .tab-content {
    grid-area: tabcontent;
    padding: 0.5em;
  }

  .tab-content-history {
    overflow: auto;
  }

  .drag-over-overlay-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-drag-over-overlay);
    color: var(--color-drag-over-overlay);
    padding: 10px;
  }

  .drag-over-overlay {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    border-radius: 1em;
    border: 10px dashed var(--color-drag-over-overlay);
    display: grid;
    grid-gap: 1em;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    align-content: center;
    align-items: center;
    justify-items: center;

    .icon {
      font-size: 10em;
    }

    .text {
      font-weight: bold;
      font-size: 2em;
      text-align: center;
    }
  }
}
</style>
